import Chart from "react-apexcharts";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { Stack } from "@bookingcom/bui-react";
import { ChartHeader } from "../ChartHeader";
import { ChartYaxisTitle } from "../ChartYaxisTitle";
import { useAverageDiscountChartController } from "./AverageDiscountChart.controller";
import type { Metric } from "../../../types";
import { CHART_HEIGHT } from "../ChartConstants";
import "../Charts.css";

export type AverageDiscountChartProps = {
  euroMetric: Metric;
  percentageMetric: Metric;
};

export const AverageDiscountChart = ({ euroMetric, percentageMetric }: AverageDiscountChartProps) => {
  const i18n = useI18n();
  const { averageDiscountEuro, averageDiscountPercentage, options, series } = useAverageDiscountChartController({
    euroMetric,
    percentageMetric,
  });

  return (
    <>
      <ChartHeader
        titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_name"))}
        titleTooltipText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_tooltip"))}
        subtitleText={i18n.trans(
          t("flights_airline_portal_realtime_performance_metric_two_subheader", {
            variables: {
              euros: averageDiscountEuro,
              percent: averageDiscountPercentage,
            },
          })
        )}
        subtitleValue={`€${averageDiscountEuro}`}
        subtitleExtra={i18n.trans(
          t("flights_airline_portal_realtime_performance_metric_two_subheader_percentage", {
            variables: {
              percent: averageDiscountPercentage,
            },
          })
        )}
      />
      <Stack mixin={{ position: "relative" }}>
        <ChartYaxisTitle titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_yaxis_a"))} />
        <ChartYaxisTitle
          titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_yaxis_b"))}
          opposite={true}
        />
        <Chart options={options} series={series} type="line" height={CHART_HEIGHT} />
      </Stack>
    </>
  );
};
